import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonLookupItem } from '@admin/shared/models/common-lookup-item.model';
import { CustomerService } from '@admin/customers/shared/services/customer.service';
import { CustomerAddEventModel } from '../shared/models/customer-add-event-model';
import { ActionResultModel } from '../../shared/models/action-result-model';
import { CustomerEventModel } from '../shared/models/customer-event-model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-customer-add-jobfair',
  templateUrl: './customer-add-jobfair.component.html',
  styleUrls: ['./customer-add-jobfair.component.less'],
  standalone: false,
})
export class CustomerAddJobfairComponent implements OnInit {
  @Input()
  public display: boolean;
  @Input()
  public customer: number;
  @Input()
  public registeredEvents: CustomerEventModel[];

  @Output()
  public onUpdate: EventEmitter<ActionResultModel> =
    new EventEmitter<ActionResultModel>();

  public events: any[];

  public packages: any[];

  public selectedEvent: number;
  public selectedPackage: number;
  public date: Date;

  public innerMsg: string;

  constructor(
    private customerService: CustomerService,
    private translateService: TranslateService
  ) {
    this.events = [];
    this.packages = [];
    this.date = null;
  }

  onEventChange() {
    this.packages = [];
    this.initPackages();
  }

  onSave() {
    if (
      this.selectedEvent == null ||
      this.selectedPackage == null ||
      this.date == null
    ) {
      this.innerMsg = this.translateService.instant(
        'message.PleaseFillAllFields'
      );
      return;
    }

    let submitData = new CustomerAddEventModel();
    submitData.customerId = this.customer;
    submitData.eventId = this.selectedEvent;
    submitData.packageId = this.selectedPackage;
    submitData.date = this.date;

    this.customerService.addEvent(submitData).subscribe((result) => {
      this.finish(result, result.success);
    });
  }

  onCancel() {
    this.finish(null);
  }

  onHide() {
    this.finish(null, false);
  }

  isAlreadyRegistered(event: CommonLookupItem<number, string>) {
    return (
      this.registeredEvents &&
      this.registeredEvents.some((re) => re.eventId == event.value)
    );
  }

  ngOnInit() {
    this.initEvents();
  }

  private initEvents() {
    this.customerService.listActiveEvents().subscribe((e) => {
      this.events = e;
    });
  }

  private initPackages() {
    this.customerService
      .listEventPackages(this.selectedEvent)
      .subscribe((p) => {
        this.packages = p;
      });
  }

  private finish(result: ActionResultModel, reset: boolean = true) {
    if (reset) {
      this.innerMsg = null;
      this.selectedEvent = null;
      this.selectedPackage = null;
      this.date = null;
    }
    this.onUpdate.emit(result);
  }
}
